/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Streetaddress1Inputs */

const en_streetaddress1 = /** @type {(inputs: Streetaddress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street Address`)
};

const de_streetaddress1 = /** @type {(inputs: Streetaddress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straßenadresse`)
};

/**
* | output |
* | --- |
* | "Street Address" |
*
* @param {Streetaddress1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const streetaddress1 = /** @type {((inputs?: Streetaddress1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Streetaddress1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_streetaddress1(inputs)
	return de_streetaddress1(inputs)
});
export { streetaddress1 as "streetAddress" }